// Boards: DeckPickerSheet (own chips under "Mine", shared under "Shared with me"), DeckPickerSheetNew (empty "Mine"
// with "Make a deck", empty "Shared with me" hint).
import React from 'react';
import { t } from '../../i18n';
import { Bdi } from '../../i18n/direction';
import { group, pickable } from './decks';
import { onTap } from './parts';

export default function DeckPicker({ tab, onTab, decks, selected, onToggle, onDone, onCreateDeck }) {
  const listed = pickable(decks, tab);
  const own = listed.filter(d => group(d) === 'own');
  const shared = listed.filter(d => group(d) === 'shared');
  const tabButton = (type, label) => (
    <button type="button" className={tab === type ? 'seg-btn seg-on' : 'seg-btn'} role="tab"
      aria-selected={tab === type ? 'true' : 'false'} onClick={() => onTab(type)}>{label}</button>
  );
  const chips = list => (
    <div className="chips">
      {list.map(d => {
        const on = selected[tab].includes(d.id);
        return (
          <button key={d.id} type="button" className={on ? 'chip chip-on' : 'chip'} aria-pressed={on ? 'true' : 'false'}
            onClick={() => onToggle(tab, d.id)}><Bdi>{d.name}</Bdi></button>
        );
      })}
    </div>
  );
  return (
    <>
      <div className="scrim"></div>
      <section className="sheet" role="dialog" aria-modal="true" aria-labelledby="pick-title" style={{ gap: 14 }}>
        <span className="grab" aria-hidden="true"></span>
        <p id="pick-title" className="h-l" style={{ textAlign: 'center' }}>{t('home.decksForGame')}</p>
        <div className="seg" role="tablist" aria-label={t('picker.cardType')}>
          {tabButton('question', t('picker.questionTab', { count: selected.question.length }))}
          {tabButton('answer', t('picker.answerTab', { count: selected.answer.length }))}
        </div>
        <div className="field" style={{ gap: 8 }}>
          <p className="sec">{t('decks.starter')}</p>
          {chips(listed.filter(d => d.starter))}
          <p className="sec" style={{ marginTop: 4 }}>{t('decks.mine')}</p>
          {own.length > 0
            ? chips(own)
            : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                <p className="hint">{t('decks.noneYet')}</p>
                <a className="btn btn-sm" href="#decks" onClick={onTap(() => onCreateDeck(tab))}>{t('picker.createDeck')}</a>
              </div>
            )}
          <p className="sec" style={{ marginTop: 4 }}>{t('decks.sharedWithMe')}</p>
          {shared.length > 0 ? chips(shared) : <p className="hint">{t('decks.sharedEmpty')}</p>}
        </div>
        <a className="btn btn-dark btn-block" href="#done" onClick={onTap(onDone)}>{t('common.done')}</a>
      </section>
    </>
  );
}
